import styled from "styled-components";
import theme from "../../../styles/theme";

export const TopContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  margin-top: 4vh;
  align-items: center;
  @media ${theme.devices.tablet} {
    flex-direction: column;
    align-items: unset;
  }
`;
export const LogoImg = styled.img`
  height: 7vh;
  margin-left: 7vw;
  @media ${theme.devices.tablet} {
    margin-left: 0vw;
    height: 7vh;
  }
`;

export const TopMenuContainter = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: -16vw;
  align-items: center;
  align-self: center;
`;

export const ProfileContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-right: 2vw;
  @media ${theme.devices.tablet} {
    margin-right: 0vw;
    justify-content: center;
    margin-top: 2vh;
  }
`;
